module.exports = __webpack_public_path__ + "files/97ee0b10c0de1bcbcc00d49bc29dde76.png";